<template>
  <div>
    <p><i class="dea-ico-no-result" aria-label="Icona ad indicare che non ci sono risultati"></i></p>
    <h3 class="search-app-no-results__title">
      <slot name="title">Nessun risultato</slot>
    </h3>
    <p class="search-app-no-results__message">
      <slot>
        Siamo spiacenti, ma non sono stati trovati prodotti per "{{ query }}".<br />
        Prova ad usare i tab sopra o effettuare una nuova ricerca.
      </slot>
    </p>
  </div>
</template>

<script>
export default {
  name: "NoResults",
  props: {
    query: {
      type: String,
      default: "",
    },
  },
};
</script>
